import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Doughnut } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from "chart.js";
import HomeV2 from "./HomeV2"; // додай цей імпорт
ChartJS.register(ArcElement, Tooltip, Legend);

const Home = () => {
    const [blobs, setBlobs] = useState([]);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [blobTypeStats, setBlobTypeStats] = useState({});
    const [totalBlobs, setTotalBlobs] = useState(0);
    const [minBlobSize, setMinBlobSize] = useState(0);
    const [maxBlobSize, setMaxBlobSize] = useState(1);
    const [avgBlobSize, setAvgBlobSize] = useState(0);
    const [blobsPerBlockStats, setBlobsPerBlockStats] = useState({});
    const [avgBlobPercent, setAvgBlobPercent] = useState(0);
    const [abTypeStats, setAbTypeStats] = useState({});
    const [recentlyAdded, setRecentlyAdded] = useState([]);
    const [darkMode, setDarkMode] = useState(() => {
        // Зберігаємо вибір у localStorage
        return localStorage.getItem("da_dark") === "true";
    });
    const [showV2, setShowV2] = useState(() => {
        return localStorage.getItem("da_showV2") === "true";
    });
    const recordsPerPage = 25;
    const prevBlobIds = useRef([]);

    useEffect(() => {
        const fetchBlobs = async () => {
            try {
                const response = await axios.get("https://da-dashboard-api.r1m.team/blobs/recent500");
                const blobsArr = response.data.blobs || [];
                setBlobs([...blobsArr].sort((a, b) => b.height - a.height));
                setError(null);
            } catch (err) {
                console.error("Error fetching blobs:", err.message);
                setError(null);
            }
        };

        fetchBlobs();
        const interval = setInterval(fetchBlobs, 5000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await axios.get("https://da-dashboard-api.r1m.team/static/blobs_total_data.json");
                setBlobTypeStats(response.data.blob_type_stats || {});
                setTotalBlobs(response.data.total_blobs || 0);
                setMinBlobSize(response.data.min_blob_size || 0);
                setMaxBlobSize(response.data.max_blob_size || 1);
                setAvgBlobSize(response.data.avg_blob_size || 0);
                setAvgBlobPercent(response.data.avg_blob_percent || 0);
                setAbTypeStats(response.data.ab_type_stats || {});
                setBlobsPerBlockStats(response.data.blobs_per_block_stats || {}); // ДОДАЙ ЦЕ
            } catch (err) {
                console.error("Error fetching stats:", err.message);
            }
        };

        fetchStats();
        const interval = setInterval(fetchStats, 5000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (darkMode) {
            document.body.classList.add("dark");
        } else {
            document.body.classList.remove("dark");
        }
        document.getElementById("root")?.classList.toggle("dark", darkMode);
        localStorage.setItem("da_dark", darkMode ? "true" : "false");
    }, [darkMode]);

    useEffect(() => {
        localStorage.setItem("da_showV2", showV2 ? "true" : "false");
    }, [showV2]);

    const formatBlobId = (blobId) => {
        if (!blobId) return "";
        if (blobId.length <= 16) return blobId;
        // Витягуємо 16 символів з центру без крапок
        return blobId.slice(Math.floor((blobId.length - 16) / 2), Math.floor((blobId.length + 16) / 2));
    };
    const formatNamespace = (ns) => ns ? ns.slice(-16) : "";
    const sortedBlobs = [...blobs]
  .filter(b => b && b.blob_id) // тільки валідні
  .sort((a, b) => (b.height || b.block) - (a.height || a.block));

// 2. Видалити дублікати по blob_id
const uniqueBlobsMap = new Map();
for (const blob of sortedBlobs) {
  if (!uniqueBlobsMap.has(blob.blob_id)) {
    uniqueBlobsMap.set(blob.blob_id, blob);
  }
}
const uniqueBlobs = Array.from(uniqueBlobsMap.values());

// 3. panelBlobs — це перші 90 унікальних blobs
const rows = 2;
const cols = 45;
const maxSquares = rows * cols;
const panelBlobs = uniqueBlobs.slice(0, maxSquares);
const emptySquares = maxSquares - panelBlobs.length;

    const blobTypeLabels = [
        "TX Blob",
        "NFT Blob",
        "Zk Rollup TX",
        "AI Spam",
        "Test/Debug Blob",
        "Other/Unclassified"
    ];

    const blobTypePercents = blobTypeLabels.map(
        label => blobTypeStats[label]?.percent ?? 0
    );

    const otherDoughnutData = {
        labels: blobTypeLabels,
        datasets: [
            {
                data: blobTypePercents,
                backgroundColor: [
                    "#8e2fff", // TX Blob (фіолетовий)
                    "#ff4ecd", // NFT Blob (рожевий)
                    "#c299fc", // Zk Rollup TX (світлий фіолетовий)
                    "#f3bfff", // AI Spam (світлий рожевий)
                    "#e9d7fd", // Test/Debug Blob (ще світліший фіолетовий)
                    "#f8f0ff"  // Other/Unclassified (дуже світлий фон)
                ],
                borderWidth: 2,
                hoverOffset: 8
            }
        ]
    };

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = sortedBlobs.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(sortedBlobs.length / recordsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const renderPagination = () => {
        const paginationButtons = [];
        const totalButtons = 10; // Завжди відображати 10 кнопок
        const lastPage = totalPages; // Остання сторінка

        if (totalPages <= totalButtons) {
            // Якщо сторінок менше або дорівнює 10, показуємо всі
            for (let i = 1; i <= totalPages; i++) {
                paginationButtons.push(
                    <button
                        key={i}
                        className={`page-button ${currentPage === i ? "active" : ""}`}
                        onClick={() => handlePageChange(i)}
                    >
                        {i}
                    </button>
                );
            }
        } else {
            // Завжди додаємо першу сторінку
            paginationButtons.push(
                <button
                    key={1}
                    className={`page-button ${currentPage === 1 ? "active" : ""}`}
                    onClick={() => handlePageChange(1)}
                >
                    1
                </button>
            );

            let startPage, endPage;

            if (currentPage <= 5) {
                // Якщо поточна сторінка ближче до початку
                startPage = 2;
                endPage = totalButtons - 2; // Зарезервуємо місце для останньої сторінки
            } else if (currentPage >= totalPages - 4) {
                // Якщо поточна сторінка ближче до кінця
                startPage = totalPages - (totalButtons - 3);
                endPage = totalPages - 1;
            } else {
                // Якщо поточна сторінка посередині
                startPage = currentPage - 4;
                endPage = currentPage + 4;
            }

            // Додаємо кнопки в діапазоні від startPage до endPage
            for (let i = startPage; i <= endPage; i++) {
                paginationButtons.push(
                    <button
                        key={i}
                        className={`page-button ${currentPage === i ? "active" : ""}`}
                        onClick={() => handlePageChange(i)}
                    >
                        {i}
                    </button>
                );
            }

            // Завжди додаємо останню сторінку
            paginationButtons.push(
                <button
                    key={lastPage}
                    className={`page-button ${currentPage === lastPage ? "active" : ""}`}
                    onClick={() => handlePageChange(lastPage)}
                >
                    {lastPage}
                </button>
            );
        }

        return paginationButtons;
    };

    // Для minPercent:
    const minPercent = Math.round((minBlobSize / maxBlobSize) * 100);

    // Витягуємо дані для Average Quality Score doughnut
    const avgQualityPercent = Math.round(avgBlobPercent); // якщо avg_blob_percent = 60, буде 60%
    const avgQualityStr = `${Math.round(avgBlobSize)}`; // просто число, без "B" (B додамо стилем)

    const avgQualityDoughnutData = {
        labels: ["Average Quality"],
        datasets: [
            {
                data: [avgQualityPercent, 100 - avgQualityPercent],
                backgroundColor: [
                    "#8e2fff", // Основний Celestia фіолетовий
                    "#f8f0ff"  // Дуже світлий фон
                ],
                borderWidth: 0,
                hoverOffset: 0
            },
        ],
    };

    const avgQualityDoughnutOptions = {
        cutout: "70%",
        animation: false,
        plugins: {
            tooltip: { enabled: false }, // Вимикаємо tooltip
            legend: { display: false },
        },
    };

    // Витягуємо останні 60 blobs (або менше)
    const latestBlobs = sortedBlobs.slice(0, 60);

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
    };

    function timeAgo(dateString) {
        const now = new Date();
        const date = new Date(dateString);
        const diff = Math.floor((now - date) / 1000); // seconds

        if (diff < 5) return "just now";
        if (diff < 60) return `${diff} sec${diff === 1 ? "" : "s"} ago`;
        const min = Math.floor(diff / 60);
        if (min < 60) return `${min} min${min === 1 ? "" : "s"} ago`;
        const hours = Math.floor(min / 60);
        if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
        const days = Math.floor(hours / 24);
        return `${days} day${days === 1 ? "" : "s"} ago`;
    }

    // Створюємо мапу namespace → blob_id
    const namespaceToBlobId = {};
    sortedBlobs.forEach(blob => {
        const ns = blob.namespace_id || blob.namespace || "";
        if (ns && blob.blob_id && !namespaceToBlobId[ns]) {
            namespaceToBlobId[ns] = blob.blob_id;
        }
    });

    // Дані для IBC Blobs (A/B)
    const abTypePercents = [
        blobTypeStats["A"]?.percent ?? 0,
        blobTypeStats["B"]?.percent ?? 0,
        blobTypeStats["Unknown"]?.percent ?? 0
    ];

    // Якщо у вас є окремий ab_type_stats з бекенду:
    const abDoughnutData = {
        labels: ["A", "B", "Unknown"],
        datasets: [
            {
                data: [
                    abTypeStats["A"]?.percent ?? 0,
                    abTypeStats["B"]?.percent ?? 0,
                    abTypeStats["Unknown"]?.percent ?? 0
                ],
                backgroundColor: [
                    "#e9d7fc", // A (світлий рожевий)
                    "#c29af9", // B (фіолетовий)
                    "#8e34fb"  // Unknown (світлий фіолетовий)
                ],
                borderWidth: 0,
                hoverOffset: 0
            }
        ]
    };

    const abDoughnutOptions = {
        cutout: "70%",
        animation: false,
        plugins: {
            tooltip: { enabled: false },
            legend: { display: false }
        }
    };

    // Визначаємо нові blobs
    useEffect(() => {
        const newIds = panelBlobs
            .map(b => b.blob_id)
            .filter(id => id && !prevBlobIds.current.includes(id));
        if (newIds.length > 0) {
            setRecentlyAdded(prev => [...prev, ...newIds]);
            setTimeout(() => {
                setRecentlyAdded(prev => prev.filter(id => !newIds.includes(id)));
            }, 1000); // 1 секунда
        }
        prevBlobIds.current = panelBlobs.map(b => b.blob_id);
    }, [panelBlobs]);

    // Додаємо мапу для кольорів типів blob'ів (як у Blobs %)
    const blobTypeColors = {
        "TX Blob": "#8e2fff",            // фіолетовий
        "NFT Blob": "#ff4ecd",           // рожевий
        "Zk Rollup TX": "#c299fc",       // світлий фіолетовий
        "AI Spam": "#f3bfff",            // світлий рожевий
        "Test/Debug Blob": "#e9d7fd",    // ще світліший фіолетовий
        "Other/Unclassified": "#f8f0ff", // дуже світлий фон
        "Other / Unclassified": "#f8f0ff" // для сумісності з бекендом
    };

    if (showV2) {
        return (
            <HomeV2
                onSwitchV1={() => setShowV2(false)}
                darkMode={darkMode}
                setDarkMode={setDarkMode}
            />
        );
    }

    return (
        <div className={`dashboard-container${darkMode ? " dark" : ""}`}>
            <header className="dashboard-header">
    <div className="header-left">
      {/* Перемикач теми */}
      <div className={`theme-switch${darkMode ? ' active dark' : ''}`} onClick={() => setDarkMode(v => !v)}>
        <div className="switch-track"></div>
        <div className="switch-thumb">
          {darkMode ? (
            // Білий місяць SVG
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
              <path d="M15.5 13.5A7 7 0 0 1 6.5 4.5a7 7 0 1 0 9 9z" fill="#fff"/>
            </svg>
          ) : (
            // Біле сонце SVG
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="5" fill="#fff"/>
              <g stroke="#fff" strokeWidth="1.5">
                <line x1="10" y1="1" x2="10" y2="4"/>
                <line x1="10" y1="16" x2="10" y2="19"/>
                <line x1="1" y1="10" x2="4" y2="10"/>
                <line x1="16" y1="10" x2="19" y2="10"/>
                <line x1="4.22" y1="4.22" x2="6.34" y2="6.34"/>
                <line x1="13.66" y1="13.66" x2="15.78" y2="15.78"/>
                <line x1="4.22" y1="15.78" x2="6.34" y2="13.66"/>
                <line x1="13.66" y1="6.34" x2="15.78" y2="4.22"/>
              </g>
            </svg>
          )}
        </div>
      </div>
    </div>
    <div className="header-center">
      <img
        src="/images/celestia_logo.png"
        alt="Logo"
        style={{
          height: 48,
          marginRight: 16,
          verticalAlign: "middle",
          display: "inline-block"
        }}
      />
      <h1 style={{ margin: 0, display: "inline-block", verticalAlign: "middle" }}>
        AI-POWERED DA DASHBOARD
      </h1>
      <span className="version-label">
  v0.2.2-beta
</span>
    </div>
    <div className="header-right">
      {/* Version switch toggle (V1↔V2) */}
      <div
        className={`theme-switch version-switch${showV2 ? ' active' : ''}`}
        onClick={() => setShowV2(v => !v)}
        title={showV2 ? 'Switch to V1' : 'Switch to V2'}
        style={{ marginLeft: 16 }}
      >
        <div className="switch-track"></div>
        <div className="switch-thumb version-thumb">
          <span style={{ fontSize: 11, fontWeight: 700, color: '#fff', letterSpacing: 0.5 }}>
            V2
          </span>
        </div>
      </div>
    </div>
  </header>

            {error && <p className="error">{error}</p>}

            <div className="dashboard-main-row">
                <div className="stats-grid custom-stats-grid">
                    {/* Верхній ряд — 5 блоків */}
                    <div className="stat-card compact">
    <h2>Tx Blobs</h2>
    <p>{blobTypeStats["TX Blob"]?.count ?? 0}</p>
  </div>
  <div className="stat-card compact">
    <h2>Zk Rollup Blobs</h2>
    <p>{blobTypeStats["Zk Rollup TX"]?.count ?? 0}</p>
  </div>
  <div className="stat-card compact">
    <h2>Test/Debug Blobs</h2>
    <p>{blobTypeStats["Test/Debug Blob"]?.count ?? 0}</p>
  </div>
  <div className="stat-card compact">
    <h2>Solo/Multi Blobs</h2>
    <div style={{ width: 70, height: 70, margin: "0 auto" }}>
      <Doughnut
        data={abDoughnutData}
        options={{
          cutout: "70%",
          animation: false,
          plugins: {
            legend: { display: false },
            tooltip: {
              enabled: true,
              callbacks: {
                title: function() { return ""; },
                label: function(context) {
                  const label = context.label;
                  const count =
                    label === "A"
                      ? abTypeStats["A"]?.count ?? 0
                      : label === "B"
                      ? abTypeStats["B"]?.count ?? 0
                      : abTypeStats["Unknown"]?.count ?? 0;
                  const desc =
                    label === "A"
                      ? "Solo Blob"
                      : label === "B"
                      ? "Multi Blob"
                      : "Unknown";
                  return `${desc}: ${count}`;
                }
              },
              backgroundColor: "#343a40",
              titleColor: "#fff",
              bodyColor: "#fff",
              displayColors: false,
              padding: 10,
              caretSize: 6,
              borderRadius: 8,
              borderColor: "#23272f",
              borderWidth: 2
            }
          }
        }}
      />
    </div>
  </div>
  <div className="stat-card compact total-blobs-card">
    <h2 className="total-blobs-title">Total Blobs</h2>
    <div className="total-blobs-value">
        {totalBlobs}
    </div>
</div>
<div className="stat-card compact">
    <h2 className="blob-size-title">Min/Max Blobs Size</h2>
    <div className="blob-size-row">
        <span className="blob-size-value">{minBlobSize} B</span>
    </div>
    <div className="blob-size-bar min">
        <div className="blob-size-bar-inner min" style={{ width: `${minPercent}%` }} />
    </div>
    <div className="blob-size-row">
        <span className="blob-size-value">{maxBlobSize} B</span>
    </div>
    <div className="blob-size-bar max">
        <div className="blob-size-bar-inner max" style={{ width: `100%` }} />
    </div>
</div>
  {/* Нижній ряд — 4 блоки */}
  <div className="stat-card compact">
    <h2>Other Blobs</h2>
    <p>{blobTypeStats["Other/Unclassified"]?.count ?? 0}</p>
  </div>
  <div className="stat-card compact">
    <h2>AI Spam Blobs</h2>
    <p>{blobTypeStats["AI Spam"]?.count ?? 0}</p>
  </div>
  <div className="stat-card compact">
    <h2>Max Blobs per Block</h2>
    <p>{blobsPerBlockStats?.max ?? 0}</p>
  </div>
                    <div className="stat-card compact avg-quality">
                        <h2 className="doughnut-title">Average Quality</h2>
                        <div style={{ position: "relative", width: 70, height: 70 }}>
                            <Doughnut data={avgQualityDoughnutData} options={avgQualityDoughnutOptions} />
                            <div
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    textAlign: "center",
                                    fontWeight: 700,
                                    fontSize: 13,
                                    color: "#1e1e1e", // Celestia purple
                                    pointerEvents: "none",
                                    width: "100%",
                                    lineHeight: 1.1,
                                }}
                            >
                                {avgQualityPercent}%
    <div style={{ fontSize: 11, color: "#888", fontWeight: 500, letterSpacing: 0.5 }}>
        {avgQualityStr} <span style={{ fontSize: 9 }}>B</span>
    </div>
                            </div>
                        </div>
                    </div>
                    <div className="doughnut-card other">
                        <h2 className="doughnut-title">Blobs %</h2>
                        <Doughnut
                            data={otherDoughnutData}
                            options={{
                                cutout: '60%', // або 65% для трохи тоншого кільця
                                plugins: {
                                    legend: { display: false },
                                    tooltip: {
                                        enabled: true,
                                        callbacks: {
                                            title: function(context) {
                                                return context[0].label;
                                            },
                                            label: function() {
                                                return '';
                                            }
                                        },
                                        backgroundColor: "#343a40", // темно-сірий як у шапці
                                        titleColor: "#fff",
                                        bodyColor: "#fff",
                                        displayColors: false,
                                        padding: 10,
                                        caretSize: 6,
                                        borderRadius: 8, // для сучасного вигляду
                                        borderColor: "#23272f", // можна додати темнішу рамку
                                        borderWidth: 2
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* Додаємо блок Blobs Panel */}
        <div className="blobs-panel-card">
            <div className="blobs-panel-title">Solo Blobs Panel</div>
            <div className="blobs-panel-grid">
  {panelBlobs.map((blob, idx) => {
    let type = blob.ai_type;
    if (!type || type === "Other / Unclassified") type = "Other/Unclassified";
    const color = blobTypeColors[type] || "#f8f0ff";
    const isNew = recentlyAdded.includes(blob.blob_id);
    return (
      <div
        key={blob.blob_id || idx}
        className={`blob-square${blob.error ? " blob-error" : ""}${isNew ? " new-blob" : ""}`}
        title={blob.ai_type || "Unknown"}
        style={{ background: color }}
      />
    );
  })}
  {[...Array(emptySquares)].map((_, idx) => (
    <div key={`empty-${idx}`} className="blob-square blob-empty" />
  ))}
</div>
        </div>

<h2 className="blobs-activity-title">Blobs Activity</h2>
            <div className="table-container">
                <table className="activity-table">
                    <thead>
                        <tr>
                            <th>Block</th>
                            <th>Blob ID</th>
                            <th>Namespace</th>
                            <th>Type</th>
                            <th>Rollup</th>
                            <th>Quality B</th>
                            <th>Quality %</th>
                            <th>Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentRecords.map((blob, index) => {
                            const ns = blob.namespace_id || blob.namespace || "";
                            const displayBlobId = blob.blob_id || namespaceToBlobId[ns] || "";
                            return (
                                <tr key={index}>
                                    <td>{blob.height || ""}</td>
                                    <td
                                        style={{ cursor: "pointer", userSelect: "all" }}
                                        title={displayBlobId}
                                        onClick={() => handleCopy(displayBlobId)}
                                    >
                                        {formatBlobId(displayBlobId)}
                                    </td>
                                    <td
                                        style={{ cursor: "pointer", userSelect: "all" }}
                                        title={ns}
                                        onClick={() => handleCopy(ns)}
                                    >
                                        {formatNamespace(ns)}
                                    </td>
                                    
                                    <td>
  {(blob.ai_type === "Other / Unclassified")
    ? "Other/Unclassified Blob"
    : (blob.ai_type || "")}
</td>
                                    <td>
  {blob.rollup && blob.rollup.name
    ? blob.rollup.name
    : (blob.rollup_name && blob.rollup_name.trim() !== "" ? blob.rollup_name : "Unverified")}

                                    </td>
                                    <td>
  {(blob.quality || blob.size || "") + (blob.quality || blob.size ? " B" : "")}
</td>
<td>
  {blob.percent_full !== undefined
    ? (typeof blob.percent_full === "number"
        ? blob.percent_full.toFixed(2) + " %"
        : blob.percent_full)
    : ""}
    </td>
                                    <td>{blob.time ? timeAgo(blob.time) : ""}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div className="pagination">
                {renderPagination()}
            </div>

            <footer className="footer">
                <p>
                    ©{" "}
                    <a
                        href="https://r1m.team"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer-link"
                    >
                        R1M
                    </a>{" "}
                    2025. All rights reserved.
                </p>
            </footer>
        </div>
    );
};

export default Home;

